'use client';

import { c as _c } from "react/compiler-runtime";
import type { Ref } from 'react';
import { getImageProxyUrl } from '@/shared/lib/proxy-url';
import { useTranslations } from 'next-intl';
import styles from './SampleImagePicker.module.scss';
import { AI_EXPERIENCE_SAMPLES, type AiExperienceSampleId } from './samples';
interface SampleImagePickerProps {
  onSelect: (id: AiExperienceSampleId) => void;
  selectedId?: AiExperienceSampleId | null;
  disabled?: boolean;
  ref?: Ref<HTMLDivElement>;
}
export const SampleImagePicker = t0 => {
  const $ = _c(18);
  const {
    onSelect,
    selectedId: t1,
    disabled: t2,
    ref
  } = t0;
  const selectedId = t1 === undefined ? null : t1;
  const disabled = t2 === undefined ? false : t2;
  const t = useTranslations("intro");
  let t3;
  if ($[0] !== disabled || $[1] !== onSelect) {
    t3 = id => () => {
      if (disabled) {
        return;
      }
      onSelect(id);
    };
    $[0] = disabled;
    $[1] = onSelect;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleSelect = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <img src="/intro/ic_sample.svg" alt="" className={styles.headerIcon} loading="lazy" decoding="async" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t) {
    t5 = t("aiExperience.samplePicker.header");
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <div className={styles.header}>{t4}<span className={styles.headerLabel}>{t5}</span></div>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== disabled || $[9] !== handleSelect || $[10] !== selectedId) {
    t7 = AI_EXPERIENCE_SAMPLES.map(item => {
      const isSelected = selectedId === item.id;
      const buttonClass = [styles.thumbnail, isSelected ? styles.thumbnailSelected : "", disabled ? styles.thumbnailDisabled : ""].filter(Boolean).join(" ");
      return <button key={item.id} type="button" onClick={handleSelect(item.id)} disabled={disabled} aria-pressed={isSelected} className={buttonClass}><img src={getImageProxyUrl({
          src: item.src
        })} alt={item.alt} className={styles.thumbnailImage} /></button>;
    });
    $[8] = disabled;
    $[9] = handleSelect;
    $[10] = selectedId;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <div className={styles.thumbnailRow}>{t7}</div>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== ref || $[15] !== t6 || $[16] !== t8) {
    t9 = <div ref={ref} className={styles.wrapper}>{t6}{t8}</div>;
    $[14] = ref;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};